import Transformer from "./../transformer";
import moment from "moment";
import { objectToForm } from "@/utils/";

class WorkingDayTransformer extends Transformer {
  static fetch({
    id,
    work_plan_real,
    start_date,
    finish_date,
    all_security_photos_uploaded,
  }) {
    const startDate = moment(new Date(start_date));
    let finishDate = finish_date && moment(new Date(finish_date));

    if (!finishDate) {
      finishDate = startDate.clone();
      finishDate.set({ hour: 23, minute: 59 });
    }
    return {
      id,
      workPlanReal: work_plan_real,
      startDate,
      startDateFormatted: startDate.format("YYYY-MM-DD"),
      finishDate,
      allSecurityPhorosUploaded: all_security_photos_uploaded,
    };
  }
}

const setupPhotosInfo = (realPlan) => {
  const obj = {};

  const startDate = realPlan.startDate;
  const finishDate = realPlan.finishDate || new Date();

  const start = moment(startDate, "YYYY-MM-DD");
  const end = moment(finishDate, "YYYY-MM-DD");

  realPlan.moment = { start, end };

  const pDays = moment.duration(end.diff(start)).asDays();

  realPlan.duration = pDays;

  const sDate = start.clone();

  for (let i = 0; i <= pDays; i++) {
    obj[sDate.format("YYYY-MM-DD")] = false;
    sDate.add(1, "days");
  }

  const photosInfo = realPlan.photos_info || [];

  for (const date of photosInfo) {
    obj[date] = true;
  }

  return obj;
};

export default class RealtedTransformer extends Transformer {
  static send(real) {
    const delay_reason = !!real.delayReason ? real.delayReason : undefined;
    return objectToForm({
      plan_expected: real.planExpected,
      finish_work_date: real.finishDate,
      first_photo: real.firstPhoto,
      delay_reason,
    });
  }

  static fetch({ working_days, ...real }) {
    const workingDays = WorkingDayTransformer.fetchCollection(working_days);

    const transformed = {
      id: real.id,
      // :NOTE: If planExpected were expanded by then backend
      // we should update this, though it seems innecessary
      // since real are fetched along with expected plans.
      planExpected: real.plan_expected,
      planExpectedId: real.plan_expected,
      startDate: real.start_work_date,
      finishDate: real.finish_work_date,
      finish_working_hours: real.finishWorkingHours,
      workingDays,
      ...real,
    };
    transformed.photosInfo = setupPhotosInfo(transformed);
    transformed.finishsToday = moment(transformed.finishDate).isSame(
      moment(new Date()),
      "day"
    );

    const uniqueDates = new Set(
      workingDays.map(({ startDateFormatted }) => startDateFormatted)
    );

    if (uniqueDates.size < workingDays.length) {
      transformed.hasDuplicatedWorkingDays = true;
    }
    return transformed;
  }
}



// WEBPACK FOOTER //
// ./src/transformers/workPlan/real.js